import { render } from "./BusinessPhone.vue?vue&type=template&id=51c69b03&scoped=true"
import script from "./BusinessPhone.vue?vue&type=script&lang=js"
export * from "./BusinessPhone.vue?vue&type=script&lang=js"

import "./BusinessPhone.vue?vue&type=style&index=0&id=51c69b03&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c69b03"]])

export default __exports__